import { getExplorationType } from '@/core/exploration';
import { CloseButton } from '@/components/button';
import { useLayoutContext } from '@/components/layout/layout-context';

import { SidebarSection } from '../../sidebar-section';
import { ExplorationSettings } from '../../settings';
import { ExplorationOutline } from '../../exploration-outline';
import { useExplorationContext } from '../../exploration-context';
import { useExplorationUIContext } from '../../exploration-ui-context';

import styles from '../sidebar.module.scss';

interface ExplorationSidebarProps {
  activeTabId: string | null;
  onAddCell: (index: number, tabId?: string | null) => void;
  onAddTab: (name: string) => void;
  onDeleteTab: (tabId: string) => void;
  onRenameTab: (tabId: string, name: string) => void;
  onDuplicateTab: (tabId: string) => void;
  onMoveTab: (fromIndex: number, toIndex: number, after: boolean) => void;
  renamingTabId: string | null;
  onSetRenamingTab: (tabId: string) => void;
  onClearRenamingTab: () => void;
}

export const ExplorationSidebar = (props: ExplorationSidebarProps) => {
  const {
    activeTabId,
    onAddCell,
    onAddTab,
    onDeleteTab,
    onRenameTab,
    onDuplicateTab,
    onMoveTab,
    renamingTabId,
    onSetRenamingTab,
    onClearRenamingTab,
  } = props;
  const { exploration, moveCell } = useExplorationContext();
  const { openEditor, scrollToCell } = useExplorationUIContext();
  const { toggleRightSidebar } = useLayoutContext();

  return (
    <>
      <SidebarSection title="Settings">
        <CloseButton className={styles.collapseButton} onClick={() => toggleRightSidebar(false)} />
        <ExplorationSettings
          exploration={exploration}
          updateDisabled={getExplorationType(exploration) !== 'exploration'}
        />
      </SidebarSection>
      <SidebarSection title="Table of Contents" scrollable>
        <ExplorationOutline
          key={exploration.explorationId}
          exploration={exploration}
          activeTabId={activeTabId}
          onSelectCell={(cellId) => {
            openEditor(cellId);
            scrollToCell(cellId);
          }}
          onAddCell={onAddCell}
          onAddTab={onAddTab}
          onDeleteTab={onDeleteTab}
          onRenameTab={onRenameTab}
          onDuplicateTab={onDuplicateTab}
          onMoveCell={moveCell}
          onMoveTab={onMoveTab}
          renamingTabId={renamingTabId}
          onSetRenamingTab={onSetRenamingTab}
          onClearRenamingTab={onClearRenamingTab}
        />
      </SidebarSection>
    </>
  );
};
